import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { extractErrorMessage, useStore } from "../../../helpers";
import { TARS_FACETS_AUTOGENERATE_ETL_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./useGetNotebooks";

export interface FacetsAutogenerateEtlPayload {
  ds: Record<string, unknown>;
  notebook_id: number;
  source_id: number;
  canvas_id: number;
  persist_facets: boolean;
  decimal_places: number;
}

export const useFacetsAutogenerateEtl = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: FacetsAutogenerateEtlPayload) => {
      const res = await rootStore.apiRequestHandler(
        TARS_FACETS_AUTOGENERATE_ETL_PATH,
        payload,
        "Failed to autogenerate facets"
      );
      return res.data ?? res;
    },
    onSuccess: (_data, variables) => {
      markTarsNotebookActivity(queryClient, variables.notebook_id);
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to autogenerate facets"));
    },
  });
};
